export const removeDupsWithinAppCurrencies = (arr, currencyTypes) => {
    return arr.filter(
        (v, i, a) => a.findIndex((t) => currencyTypes.includes(t.tag) && t.tag === v.tag && t.data === v.data) === i,
    );
};
